import { useApi } from "@/services/api";

export function useSentenceSimilarity() {

    async function compareSentences(set1: string[], set2: string[]): Promise<number[][]> {
        const api = useApi();

        const res = await api.demoCompareSentences({ requestBody: [...set1, '<SEP>', ...set2] });
        return res;
    }

    return {
        compareSentences,
    }
}